import { createBillHeadInfo } from './create';
import { setBillHeadInfoVisible, update } from './methods';

export default {
    createBillHeadInfo,
    setBillHeadInfoVisible,
    update,
}